import styled from 'styled-components'

import LevelContainer from 'components/LevelContainer'

export default styled(LevelContainer)`
  margin-bottom: 20px;
`
